var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"text-center"},[_c('h1',{staticClass:"p-5 font-size-xl"},[_vm._v(_vm._s(_vm.errorMessage))]),_c('p',{staticClass:"font-size-lg"},[_vm._v("Please retry or contact support.")]),_c('Button',{attrs:{"type":"link font-size-lg"},domProps:{"textContent":_vm._s(_vm.prev)},on:{"click":_vm.retry}},[_vm._v("retry")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }